interface Sector {
  slug: string;
  nombre: string;
  icon: string;
  tagline: string;
  desc: string;
  color: string;
  problemas: string[];
  soluciones: string[];
  ctaText: string;
  panelType: string;
  /** SEO keywords específicas para Google */
  seoKeywords: string[];
  /** Descripción larga para meta description (hasta 155 chars) */
  seoDescription: string;
}

export const SECTORES: Sector[] = [
  {
    slug: 'hosteleria',
    nombre: 'Hostelería & Restauración',
    icon: 'Coffee',
    tagline: 'Llena mesas. Automatiza reservas. Cobra online.',
    desc: 'Gestiona reservas, turnos y pagos sin levantar el teléfono.',
    color: 'amber',
    problemas: [
      'Reservas por teléfono que se solapan',
      'Sin cobro online ni señal de reserva',
      'Sin visibilidad de métricas en tiempo real',
      'Gestión manual de turnos y mesas',
    ],
    soluciones: [
      'Sistema de reservas online con calendario visual',
      'Pasarela de pago con señal o cobro total',
      'Dashboard con métricas: ocupación, ticket medio, cancelaciones',
      'Notificaciones automáticas al cliente (recordatorio, confirmación)',
    ],
    ctaText: 'Agenda tu diagnóstico gratis',
    panelType: 'reservas',
    seoKeywords: ['software hostelería', 'soluciones tecnológicas restaurantes', 'sistema reservas restaurante', 'gestión reservas hostelería', 'software restaurantes', 'cobro online restaurante', 'digitalización hostelería', 'app reservas restaurante', 'gestión mesas online', 'software bar cafetería'],
    seoDescription: 'Software de gestión para hostelería y restaurantes: reservas online, cobros digitales, dashboard de ocupación y notificaciones automáticas. Soluciones tecnológicas a medida.',
  },
  {
    slug: 'gestoria',
    nombre: 'Gestoría & Asesoría',
    icon: 'Briefcase',
    tagline: 'Automatiza la burocracia. Enfócate en tus clientes.',
    desc: 'CRM de clientes, seguimiento de expedientes y gestión documental sin papeles.',
    color: 'blue',
    problemas: [
      'Expedientes en Excel que nadie actualiza',
      'Comunicación por WhatsApp sin registro',
      'Sin portal de cliente para documentación',
      'Tiempo perdido en tareas administrativas repetitivas',
    ],
    soluciones: [
      'CRM con seguimiento de expedientes en tiempo real',
      'Portal de cliente para subir/descargar documentación',
      'Automatizaciones de recordatorios y vencimientos',
      'Integración con herramientas de firma digital',
    ],
    ctaText: 'Pedir diagnóstico gratuito',
    panelType: 'crm',
    seoKeywords: ['software gestoría', 'CRM asesoría fiscal', 'gestión expedientes digital', 'software asesoría contable', 'portal cliente gestoría', 'digitalización gestoría', 'automatización gestoría', 'gestión documental asesoría', 'software despacho profesional', 'gestoría online'],
    seoDescription: 'Software de gestión para gestorías y asesorías: CRM de clientes, expedientes digitales, portal de documentación y automatización de recordatorios. Sin papel, sin caos.',
  },
  {
    slug: 'construccion',
    nombre: 'Construcción & Reformas',
    icon: 'Building2',
    tagline: 'Proyectos bajo control. Clientes satisfechos.',
    desc: 'Gestión de obras, presupuestos automáticos y seguimiento en tiempo real.',
    color: 'orange',
    problemas: [
      'Presupuestos que tardan días en enviarse',
      'Sin seguimiento del estado de cada obra',
      'Comunicación desorganizada con equipos',
      'Facturas y cobros gestionados a mano',
    ],
    soluciones: [
      'Generador de presupuestos automático en minutos',
      'Panel de seguimiento de obras por fase',
      'App para equipos en campo con updates en tiempo real',
      'Facturación y cobros integrados con recordatorios',
    ],
    ctaText: 'Solicitar diagnóstico',
    panelType: 'dashboard',
    seoKeywords: ['software construcción', 'software reformas', 'gestión obras digital', 'presupuestos automáticos construcción', 'seguimiento obras online', 'app equipo obra', 'software empresa constructora', 'facturación reformas', 'ERP construcción', 'digitalización constructora'],
    seoDescription: 'Software de gestión para construcción y reformas: presupuestos automáticos, seguimiento de obras por fase, app para equipos en campo y facturación integrada.',
  },
  {
    slug: 'clinicas',
    nombre: 'Clínicas & Salud',
    icon: 'HeartPulse',
    tagline: 'Más tiempo para el paciente. Menos para el papeleo.',
    desc: 'Agenda inteligente, historiales digitales y cobro online para centros de salud.',
    color: 'green',
    problemas: [
      'Agenda médica gestionada por teléfono',
      'Historiales clínicos en papel o desconectados',
      'Sin cobro online ni recordatorios automáticos',
      'Cancelaciones de última hora sin reposición',
    ],
    soluciones: [
      'Agenda online con confirmación automática',
      'Historial clínico digital accesible y seguro',
      'Pasarela de pago + recordatorios SMS/email',
      'Lista de espera automática en cancelaciones',
    ],
    ctaText: 'Hablar con el equipo',
    panelType: 'reservas',
    seoKeywords: ['software clínicas', 'software centro médico', 'agenda médica online', 'historial clínico digital', 'software salud', 'gestión citas médicas', 'cobro online clínica', 'software dental', 'software fisioterapia', 'digitalización clínica'],
    seoDescription: 'Software de gestión para clínicas y centros de salud: agenda inteligente, historiales digitales, cobro online y recordatorios automáticos. Más tiempo para el paciente.',
  },
  {
    slug: 'formacion',
    nombre: 'Centro de Formación',
    icon: 'GraduationCap',
    tagline: 'Más alumnos. Menos gestión.',
    desc: 'Plataforma de inscripciones, pagos y seguimiento de alumnos totalmente automatizada.',
    color: 'violet',
    problemas: [
      'Inscripciones por email o WhatsApp sin control',
      'Sin cobro online para cursos y formaciones',
      'Sin seguimiento del progreso del alumno',
      'Gestión manual de certificados y diplomas',
    ],
    soluciones: [
      'Portal de inscripciones con pago online',
      'Dashboard de alumnos con progreso y asistencia',
      'Generación automática de certificados',
      'Email marketing integrado para fidelización',
    ],
    ctaText: 'Ver cómo funciona',
    panelType: 'dashboard',
    seoKeywords: ['software centro formación', 'plataforma inscripciones online', 'gestión alumnos digital', 'software academia', 'cobro cursos online', 'certificados automáticos', 'software escuela', 'LMS a medida', 'gestión formación', 'digitalización centro educativo'],
    seoDescription: 'Software para centros de formación y academias: inscripciones online, cobro de cursos, seguimiento de alumnos y generación automática de certificados.',
  },
  {
    slug: 'ecommerce',
    nombre: 'E-commerce & Retail',
    icon: 'ShoppingBag',
    tagline: 'Vende más. Opera menos.',
    desc: 'Tienda online de alto rendimiento con gestión de stock y automatizaciones de ventas.',
    color: 'pink',
    problemas: [
      'Tienda online lenta que pierde conversiones',
      'Sin gestión de stock en tiempo real',
      'Emails de carrito abandonado no configurados',
      'Sin métricas de productos más rentables',
    ],
    soluciones: [
      'Web de alto rendimiento optimizada para conversión',
      'Gestión de inventario en tiempo real',
      'Automatizaciones: carrito abandonado, upsell, reactivación',
      'Dashboard de ventas con margen por producto',
    ],
    ctaText: 'Empezar diagnóstico',
    panelType: 'dashboard',
    seoKeywords: ['software ecommerce', 'tienda online alto rendimiento', 'gestión stock tiempo real', 'software retail', 'carrito abandonado automatización', 'dashboard ventas ecommerce', 'software tienda online', 'ERP ecommerce', 'digitalización comercio', 'plataforma ventas online'],
    seoDescription: 'Software para e-commerce y retail: tienda online de alto rendimiento, gestión de stock en tiempo real, automatizaciones de venta y dashboard de métricas por producto.',
  },
  {
    slug: 'peluqueria',
    nombre: 'Peluquería & Estética',
    icon: 'Scissors',
    tagline: 'Silla llena. Sin estrés.',
    desc: 'Reservas online, pagos y fidelización de clientes automatizados.',
    color: 'rose',
    problemas: [
      'Agenda gestionada por WhatsApp o llamadas',
      'Sin recordatorio automático al cliente',
      'Cancelaciones sin opción de rellenar el hueco',
      'Sin programa de fidelización ni seguimiento',
    ],
    soluciones: [
      'Reservas online 24/7 con selección de profesional',
      'Recordatorios automáticos por WhatsApp/email',
      'Lista de espera automática en cancelaciones',
      'Programa de puntos y fidelización integrado',
    ],
    ctaText: 'Pedir diagnóstico',
    panelType: 'reservas',
    seoKeywords: ['software peluquería', 'reservas online peluquería', 'software estética', 'gestión citas peluquería', 'app reservas belleza', 'fidelización clientes peluquería', 'software centro belleza', 'agenda peluquería online', 'cobro online peluquería', 'digitalización peluquería'],
    seoDescription: 'Software para peluquerías y centros de estética: reservas online 24/7, recordatorios automáticos, lista de espera inteligente y programa de fidelización.',
  },
];
